// extracted by mini-css-extract-plugin
module.exports = {"tabsComponent":"TabComponent_tabsComponent__2WkUD","tabs":"TabComponent_tabs__ONLGj","tab":"TabComponent_tab__1VM6t","activeTab":"TabComponent_activeTab__3VFTP"};